import { render, staticRenderFns } from "./OrdenCompraContratos.vue?vue&type=template&id=896a8100&"
import script from "./OrdenCompraContratos.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraContratos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports